<template>
  <div class="record">
    <div class="dataPage">
      <div class="headLine">
        <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
        数据录入
      </div>
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="100px"
        :rules="rules"
      >
        <div class="dataPost">
          <el-form-item label="录入日期:" prop="date">
            <el-date-picker
              v-model="dataForm.date"
              type="date"
              @change="timeGetData"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="录入时间:" prop="time">
            <el-time-picker
              v-model="dataForm.time"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
            />
          </el-form-item>
          <el-form-item label="流量计:" prop="areaId">
            <el-select v-model="dataForm.areaId" @change="selectData" placeholder="请选择录入流量计">
              <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.flowMeterName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="dataPost" :style="{marginBottom: (isiPhoneX == true ? heightTop : '')}">
          <h5>数据</h5>
          <div class="lastData" v-if="lastData && lastData.id">
            <div class="lastTime">上次录入：{{ lastData.dateTime }}</div>
            <div class="lastValue">{{ lastData.positiveFlow }}</div>
          </div>
          <el-form-item label="正流量行度:" prop="positiveFlow">
            <el-input v-model="dataForm.positiveFlow" type="number" placeholder="正流量行度数值（单位m³）" />
          </el-form-item>
          <div class="lastData" v-if="lastData && lastData.id">
            <div class="lastTime">上次录入：{{ lastData.dateTime }}</div>
            <div class="lastValue">{{ lastData.negativeFlow }}</div>
          </div>
          <el-form-item label="负流量行度:" prop="negativeFlow">
            <el-input v-model="dataForm.negativeFlow" type="number" placeholder="负流量行度数值（单位m³）" />
          </el-form-item>
          <div class="lastData" v-if="lastData && lastData.id">
            <div class="lastTime">上次录入：{{ lastData.dateTime }}</div>
            <div class="lastValue">{{ lastData.instantFlow }}</div>
          </div>
          <el-form-item label="瞬时流量:" prop="instantFlow">
            <el-input v-model="dataForm.instantFlow" type="number" placeholder="瞬时流量数值（单位m³）" />
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="dataForm.remark" rows="5"></el-input>
          </el-form-item>
        </div>
        <div class="footList" :style="{marginBottom: (isiPhoneX == true ? heightTop : '')}">
          <el-button @click="resetForm">重置</el-button>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data () {
    return {
      popstateLock: 0,//是否监听物理返回键
      dataForm: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        time: moment(new Date()).format("HH:mm"),
        areaId: null, // 流量计
        area: null,
        positiveFlow: null, // 正流量行度
        negativeFlow: null, // 负流量行度
        instantFlow: null,  // 瞬时流量
        operator: null,
        remark: null
      },
      stationOptions: [],
      rules: {
        date: [{ required: true, message: '请选择好日期', trigger: 'blur' }],
        time: [{ required: true, message: '请选择好时间', trigger: 'blur' }],
        areaId: [{ required: true, message: '请选择流量计', trigger: 'blur' }],
        positiveFlow: [{ required: true, message: '请输入正流量行度', trigger: 'blur' }],
        negativeFlow: [{ required: true, message: '请输入负流量行度', trigger: 'blur' }],
      },
      orderData: {},
      lastData: {},
      isiPhoneX: false,
      heightTop: null,
      loading: true
    }
  },
  created() {
    this.isIPhoneX();
    this.getAreaOption();
  },
  mounted () {
    this.getQuery();
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 流量计信息获取
    getAreaOption() {
      this.$http.httpGet('/app/tbEquipment/combo', {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.stationOptions = res.list
        } else {
          this.stationOptions = [];
          this.$message.error('获取数据失败: ' + res.msg)
        }
      })
    },
    // 赋值
    selectData(val) {
      let selectDataOn = this.stationOptions.filter(item => item.id === val);
      this.dataForm.area = selectDataOn[0].flowMeterName;
      // 获取上一次录入数据
      this.$http.httpGet(`/app/tbCopyFlowData/lastInfo/${val}`, {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.tbCopyFlowData && res.tbCopyFlowData.id) {
            res.tbCopyFlowData.dateTime = res.tbCopyFlowData.date.substr(0, 10);
            this.lastData = res.tbCopyFlowData
          } else {
            this.lastData = {}
          }
        } else {
          this.lastData = {};
          this.$message.error('获取数据失败: ' + res.msg)
        }
      })
    },
    // 获取时间来获取最新的参数
    timeGetData(timeData) {
      console.log(timeData)
      if (this.dataForm.areaId === null || this.dataForm.areaId === "") {
        this.$message.error("请选择好流量计后，再进行查询数据");
      } else {
        this.$http.httpGet(`/app/tbCopyFlowData/lastInfoByDate`, {
          id: this.dataForm.areaId,
          inputDate: this.dataForm.date
        }).then(res => {
          if (res.code === 0 && res.msg === 'success') {
            console.log(res)
            if (res.tbCopyFlowData && res.tbCopyFlowData.id) {
              res.tbCopyFlowData.dateTime = res.tbCopyFlowData.date.substr(0, 10);
              this.lastData = res.tbCopyFlowData
            } else {
              this.lastData = {}
            }
          } else {
            this.lastData = {};
            this.$message.error('获取数据失败: ' + res.msg)
          }
        })

      }
    },
    // 获取到传过来的参数
    async getQuery () {
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      })
      this.orderData = []
    },
    // 提交
    onSubmit() {
      this.dataForm.negativeFlow = this.dataForm.negativeFlow || 0;
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let TheTime = this.dataForm.date + ' ' + this.dataForm.time + ":00";
          this.$http.httpGet('/app/tbCopyFlowData/isExistData', {
            id: this.dataForm.areaId,
            inputDate: this.dataForm.date,
          }).then(res => {
            if (res && res.code === 0) {
              if (res.isExist) {  // 判断是否
                this.$confirm('该日期已经有数据，请确认是否覆盖数据?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.sureComfirm(TheTime);
                }).catch(() => {
                });
              } else {
                this.sureComfirm(TheTime);
              }
            } else {
              this.$message.error('判断数据重复数据失败: ' + res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    sureComfirm(TheTime) {
      this.$http.httpPost('/app/tbCopyFlowData/save', {
        area: this.dataForm.area,
        areaId: this.dataForm.areaId,
        date: TheTime,
        instantFlow: parseFloat(this.dataForm.instantFlow ? this.dataForm.instantFlow : 0),
        negativeFlow: parseFloat(this.dataForm.negativeFlow),
        positiveFlow: parseFloat(this.dataForm.positiveFlow),
        remark: this.dataForm.remark,
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.$message.success('提交数据成功')
          this.resetForm();
        } else {
          this.$message.error('提交数据失败: ' + res.msg)
        }
      })
    },
    // 重置数据
    resetForm() {
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      })
      this.dataForm.date = moment(new Date()).format("YYYY-MM-DD");
      this.dataForm.time = moment(new Date()).format("HH:mm");
      this.lastData = {};
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    },
    // 判断是否iPhone X
    isIPhoneX(){
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height == 812 && screen.width == 375){
          //是iphoneX
          this.isiPhoneX = true;
          this.heightTop = '40px';
        }else{
          //不是iphoneX
          this.isiPhoneX = false;
          this.heightTop = '0px';
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.record ::v-deep {
  position: relative;
  .dataPage {
    position: relative;
    .headLine {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 50px;
      background-color: #409eff;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      line-height: 50px;
      text-align: center;
      img {
        height: 30px;
        margin: 10px 0;
        padding: 0 10px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .el-form {
      position: relative;
      padding: 60px 10px 50px;
      .dataPost {
        position: relative;
        overflow: hidden;
        padding: 15px 10px 0;
        background-color: #efefef;
        border-radius: 6px;
        margin: 0 0 20px;
        h5 {
          font-size: 16px;
          line-height: 1.6;
          margin: 0 0 15px;
        }
        .el-form-item {
          margin: 0 0 15px;
          .el-form-item__label {
            text-align: right;
            padding: 0 8px 0 0;
          }
          .el-form-item__content {
            .el-input {
              width: 100%;
              font-size: 12px;
            }
            .el-select {
              width: 100%;
              font-size: 12px;
            }
          }
        }
      }
      .footList {
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        border-top: 1px #efefef solid;
        width: 100%;
        z-index: 999;
        padding: 10px 0;
        text-align: center;
        .el-button {
          text-align: center;
          width: 45%;
        }
      }
    }
  }
}
.no-order {
  padding-top: 3rem;
  text-align: center;
  span {
    font-size: 1.8rem;
  }
}

.lastData {
  position: relative;
  line-height: 1.6;
  padding: 4px 0 0;
  overflow: hidden;
  font-size: 14px;
  color: #409EFF;
  .lastTime {
    float: left;
  }
  .lastValue {
    float: right;
  }
}

</style>
